import Swiper from 'swiper';
import { Pagination, Autoplay, Navigation, Controller, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';

document.addEventListener('DOMContentLoaded', function () {
    var $slider = document.querySelector('.aps_header-custom-banners');
    if (!$slider) return;

    // Se la struttura non è già Swiper-ready, la sistemiamo
    if (!$slider.querySelector('.swiper-wrapper')) {
        var wrapper = document.createElement('div');
        wrapper.className = 'swiper-wrapper';

        // Trova tutti i contenuti banners
        var items = $slider.querySelectorAll('.banner-item-content');
        items.forEach(function (item) {
            // Crea la slide
            var slide = document.createElement('div');
            slide.className = 'swiper-slide';
            // Sposta il contenuto dentro la slide
            slide.appendChild(item.cloneNode(true));
            wrapper.appendChild(slide);
            // Rimuovi l'originale
            item.parentElement.remove();
        });

        // Rimuovi tutto dal container e inserisci il nuovo wrapper
        $slider.innerHTML = '';
        $slider.appendChild(wrapper);

        // Aggiungi i controlli se non ci sono
        if (!$slider.querySelector('.swiper-button-next')) {
            var next = document.createElement('div');
            next.className = 'swiper-button-next';
            $slider.appendChild(next);
        }
        if (!$slider.querySelector('.swiper-button-prev')) {
            var prev = document.createElement('div');
            prev.className = 'swiper-button-prev';
            $slider.appendChild(prev);
        }
        if (!$slider.querySelector('.swiper-pagination')) {
            var pag = document.createElement('div');
            pag.className = 'swiper-pagination';
            $slider.appendChild(pag);
        }
    }

    var slides = $slider.querySelectorAll('.swiper-slide');
    if (slides.length > 1) {
        new Swiper($slider, {
            modules: [Autoplay, Navigation],
            loop: true,
            autoplay: { delay: 3000, disableOnInteraction: false },
            slidesPerView: "auto",
            spaceBetween: 0,
            speed: 1500,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }
        });
    }
}); 